const PRESETS = {
    netflix: { name: 'Netflix', slug: 'netflix', tint: '#E50914', tintLight: '#F6121D', textColor: '#ffffff' },
    'disney+': { name: 'Disney+', slug: 'disney-plus', tint: '#113CCF', tintLight: '#1A4FFF', textColor: '#ffffff' },
    'hbo max': { name: 'HBO Max', slug: 'hbo-max', tint: '#5822B4', tintLight: '#6B2FD4', textColor: '#ffffff' },
    'prime video': { name: 'Prime Video', slug: 'prime-video', tint: '#00A8E1', tintLight: '#0FBFFF', textColor: '#ffffff' },
    hulu: { name: 'Hulu', slug: 'hulu', tint: '#1CE783', tintLight: '#3DFF9E', textColor: '#0B0B0B' },
    'paramount+': { name: 'Paramount+', slug: 'paramount-plus', tint: '#0064FF', tintLight: '#1A7AFF', textColor: '#ffffff' },
    peacock: { name: 'Peacock', slug: 'peacock', tint: '#000000', tintLight: '#1A1A1A', textColor: '#ffffff' },
    crunchyroll: { name: 'Crunchyroll', slug: 'crunchyroll', tint: '#F47521', tintLight: '#FF8C3D', textColor: '#0B0B0B' },
    'apple tv+': { name: 'Apple TV+', slug: 'apple-tv-plus', tint: '#000000', tintLight: '#333333', textColor: '#ffffff' },
    'amazon prime video': { name: 'Prime Video', slug: 'prime-video', tint: '#00A8E1', tintLight: '#0FBFFF', textColor: '#ffffff' },
    magellantv: { name: 'MagellanTV', slug: 'magellan-tv', tint: '#1C1C1C', tintLight: '#333333', textColor: '#C4A962' },
    discovery: { name: 'Discovery', slug: 'discovery', tint: '#1472BA', tintLight: '#1A8FE3', textColor: '#ffffff' },
};

const ALIASES = {
    'amazon prime video': 'prime video', primevideo: 'prime video', 'disney plus': 'disney+', hbo: 'hbo max', max: 'hbo max',
    'paramount plus': 'paramount+', 'apple tv': 'apple tv+', 'apple tv plus': 'apple tv+', 'magellan tv': 'magellantv', 'discovery plus': 'discovery',
};

const PALETTE = [
    ['#6366F1', '#818CF8', '#ffffff'], ['#EC4899', '#F472B6', '#ffffff'], ['#F59E0B', '#FBBF24', '#0B0B0B'], ['#10B981', '#34D399', '#ffffff'],
    ['#8B5CF6', '#A78BFA', '#ffffff'], ['#EF4444', '#F87171', '#ffffff'], ['#06B6D4', '#22D3EE', '#0B0B0B'], ['#F97316', '#FB923C', '#ffffff'],
] ;

export function providerTagToLabel(tag) {
    return tag.replace(/^provider:/i, '');
}

function normalize(label) {
    return label.toLowerCase().replace(/\+/g, ' plus ').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
}

function familyKey(tag) {
    const normalized = normalize(providerTagToLabel(tag));
    const direct = Object.keys(PRESETS).find((key) => normalize(key) === normalized);
    if (direct) return direct;
    const alias = Object.entries(ALIASES).find(([key]) => normalize(key) === normalized)?.[1];
    if (alias) return alias;
    const prefix = [...Object.keys(PRESETS), ...Object.keys(ALIASES)].find((key) => normalized.startsWith(`${normalize(key)} `));
    return prefix ? ALIASES[prefix] ?? prefix : normalized;
}

export function getProviderBrand(tag) {
    const key = familyKey(tag);
    const preset = PRESETS[key];
    if (preset) return preset;
    const hash = key.split('').reduce((value, character) => ((value << 5) - value) + character.charCodeAt(0), 0);
    const [tint, tintLight, textColor] = PALETTE[Math.abs(hash) % PALETTE.length];
    return { name: providerTagToLabel(tag), slug: key.replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, ''), tint, tintLight, textColor };
}

export function discoverProviderBrands(tags) {
    const families = new Map();
    for (const tag of tags) {
        if (!tag.toLowerCase().startsWith('provider:')) continue;
        const brand = getProviderBrand(tag);
        if (!families.has(brand.slug)) families.set(brand.slug, brand);
    }
    // ReNative's loose Babel transform can compile iterable spread into
    // `[].concat(iterator)`, yielding one iterator object instead of its
    // values. Array.from is reliable in both the Web and Metro pipelines.
    return Array.from(families.values());
}
